var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"project-pdf-list"},_vm._l((_vm.pdfOptions),function(pdfOption){return _c('single-pdf-preview',{key:pdfOption.title,attrs:{"client":_vm.project ? _vm.project.client : '',"pdfOption":pdfOption,"offer":_vm.selectedOffer}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }